export default __webpack_public_path__ + "static/app-plan-fae71fec90b4060196247d1b0bea943a.jpg";